<!-- <audio class="my_audio" id="my_audio" controls preload="none">
  <source src="../../../../../assets/audios/notification.mp3" type="audio/mp3">
</audio> -->
<li ngbDropdown class="nav-item dropdown-notification mr-25">
  <!-- <button (click)="playAudio()">Play</button> -->
  <a class="nav-link" ngbDropdownToggle id="navbarNotificationDropdown" >
  <i class="ficon" data-feather="bell"></i
    ><span class="badge badge-pill badge-danger badge-up" *ngIf="this.NotificationsNbr > 0">{{this.NotificationsNbr}} </span>
  </a>
  <ul
          ngbDropdownMenu
          aria-labelledby="navbarNotificationDropdown"
          class="dropdown-menu dropdown-menu-media dropdown-menu-right"
  >
    <!-- Notifications header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Notifications</h4>
        <div class="badge badge-pill badge-light-primary" *ngIf="this.NotificationsNbr > 0">
          {{this.NotificationsNbr}} Message
        </div>
      </div>
    </li>
    <!--/ Notifications header -->

    <!-- Notifications content -->
    <li class="scrollable-container media-list" [perfectScrollbar]>
      <!--<a class="d-flex" href="javascript:void(0)" *ngFor="let message of notifications.messages">-->
      <a class="d-flex" href="javascript:void(0)"  *ngFor="let notice of this.notifications">
        <div class="media d-flex align-items-start">
          <!-- <div class="media-left">
            <div class="avatar">
              <img [src]="" width="32" height="32" />
            </div>
          </div> -->
          <div class="media-body">
            <!--<p class="media-heading" [innerHTML]="message.heading"></p>
            <small class="notification-text">{{ message.text }}</small>-->

            <div *ngIf="this.notifications">
              <p class="media-heading">{{notice.type}}</p>
              <small class="notification-text">{{notice.message}}</small>
            </div>
          </div>
        </div></a
      >
      <!--<div class="media d-flex align-items-center">
        <h6 class="font-weight-bolder mr-auto mb-0">System Notifications</h6>
        <div class="custom-control custom-control-primary custom-switch">
          <input
            class="custom-control-input"
            id="systemNotification"
            type="checkbox"
            [checked]="notifications.system"
          />
          <label class="custom-control-label" for="systemNotification"></label>
        </div>
      </div>
      <a class="d-flex" href="javascript:void(0)" *ngFor="let systemMessage of notifications.systemMessages">
        <div class="media d-flex align-items-start">
          <div class="media-left">
            <div
              class="avatar"
              [ngClass]="{
                'bg-light-danger': systemMessage.icon === 'x',
                'bg-light-success': systemMessage.icon === 'check',
                'bg-light-warning': systemMessage.icon === 'alert-triangle'
              }"
            >
              <div class="avatar-content"><i class="avatar-icon" [data-feather]="systemMessage.icon"></i></div>
            </div>
          </div>
          <div class="media-body">
            <p class="media-heading" [innerHTML]="systemMessage.heading"></p>
            <small class="notification-text">{{ systemMessage.text }}</small>
          </div>
        </div></a
      >-->
    </li>
    <!--/ Notifications content -->

    <!-- Notifications footer -->
    <li class="dropdown-menu-footer">
      <button class="btn btn-primary btn-block" (click)="goToNotices()">Lire toutes les notifications</button>
    </li>
    <!--/ Notifications footer -->
  </ul>
</li>
